import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import type { ClientFilter, ClientStats, AuthClient, PageResponse } from "./clients-types";

function getHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("tokenSession"),
  };
}

const api = axios.create({
  baseURL: ROOT_URL,
  withCredentials: false,
});

export function getClients(filter: ClientFilter): Promise<PageResponse> {
  return api
    .get("/api/auth-clients", {
      params: {
        query: filter.query || undefined,
        status: filter.status || undefined,
        page: filter.page,
        limit: filter.limit,
        sort_by: filter.sort_by || undefined,
        sort_order: filter.sort_order || undefined,
      },
      headers: getHeaders(),
    })
    .then((res) => res.data);
}

export function getClientStats(): Promise<ClientStats> {
  return api
    .get("/api/auth-clients/stats", { headers: getHeaders() })
    .then((res) => res.data);
}

export function getClient(uuid: string): Promise<AuthClient> {
  return api
    .get(`/api/auth-clients/${uuid}`, { headers: getHeaders() })
    .then((res) => res.data);
}

export function blockClient(uuid: string, reason: string): Promise<void> {
  return api
    .put(`/api/auth-clients/${uuid}/block`, { reason }, { headers: getHeaders() })
    .then(() => undefined);
}

export function unblockClient(uuid: string): Promise<void> {
  return api
    .put(`/api/auth-clients/${uuid}/unblock`, {}, { headers: getHeaders() })
    .then(() => undefined);
}

export function deleteClient(uuid: string, reason: string): Promise<void> {
  return api
    .delete(`/api/auth-clients/${uuid}`, {
      data: { reason },
      headers: getHeaders(),
    })
    .then(() => undefined);
}

export function restoreClient(uuid: string): Promise<void> {
  return api
    .put(`/api/auth-clients/${uuid}/restore`, {}, { headers: getHeaders() })
    .then(() => undefined);
}
